<script setup lang="ts"></script>

<template>
  <div class="app-footer">
    <footer class="footer">
      <nuxt-link to="/#" class="footer__logo">
        <icon size="28px" name="icons:logo3" />
      </nuxt-link>

      <nav class="footer__nav">
        <nuxt-link to="/policy" class="footer__link font-links"
          >Privacy policy</nuxt-link
        >
        <nuxt-link to="/terms" class="footer__link font-links"
          >Terms of Use</nuxt-link
        >
      </nav>

      <nuxt-link to="https://www.linkedin.com/company/switchase/" class="footer__social">
        <icon class="social-icon" size="40px" name="icons:linkedin3" />
      </nuxt-link>
    </footer>
  </div>
</template>

<style scoped>
.app-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer {
  width: 100%;
  max-width: 1440px;
  padding: 0 40px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
}

.footer__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding-right: 164px;
}

.footer__link {
  text-decoration: none;
  color: var(--main-blue);
  opacity: 0.6;
  text-transform: uppercase;
  padding: 4px;
  transition: background-color 0.3s ease, color 0.3s ease, opacity 0.3s ease;
}

.footer__link:hover {
  opacity: 1;
  background-color: var(--main-blue);
  color: var(--white);
}

.footer__link:active {
  opacity: 1;
  background-color: var(--main-blue);
  color: var(--white);
  transform: scale(0.97);
}

.social-icon {
  transition: filter 0.3s ease;
  filter: blur(0.7px);
}

.footer__social,
.footer__social span {
  cursor: pointer;
}

.footer__social:hover .social-icon {
  filter: blur(0);
}

.footer__social:active .social-icon {
  filter: blur(0);
  transform: scale(0.97);
}

@media (max-width: 1200px) {
  .footer {
    padding: 0 20px 40px;
  }
}

@media (max-width: 1023px) {
  .footer {
    justify-content: flex-start;
  }

  .footer__nav {
    margin-left: auto;
    padding-right: 40px;
  }
}

@media (max-width: 743px) {
  .footer {
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }

  .footer__nav {
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-right: 0;
    order: 3;
  }
}
</style>
